(() => {
  if (customElements.get('product-slider')) {
    return;
  }

  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.thumbs = null;
      this.sliderOptions = {};
      this.thumbsOptions = {};
      this.header = document.querySelector('.header-group');

      this.triggers = this.querySelectorAll('.product-info__thumbs .product-info__image')
      this.big = this.querySelectorAll('.product-info__image--big');
    }

    connectedCallback() {
      this.initSlider();
      this.scrollSpy();
      this.scrNav();

      window.addEventListener('scroll', this.scrNav.bind(this));
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.sliderOptions = {
        slidesPerView: 1,
        pagination: {
          el: ".product-info__slider-pagination",
          clickable: true,
        }
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);

      this.slider.on('sliderMove', () => {
        this.handleImageLoading();
      });

      if (!this.querySelector('[data-thumbs]')) return;

      this.thumbsOptions = {
        direction: 'vertical',
        slidesPerView: 4,
        spaceBetween: 20,
        slideToClickedSlide: true,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-thumbs-button-next',
          prevEl: '.swiper-thumbs-button-prev',
        },
      };

      this.thumbs = new Swiper(this.querySelector('[data-thumbs]'), this.thumbsOptions);

      this.thumbs.controller.control = this.slider;
      this.slider.controller.control = this.thumbs;

    }

    // This method is called when the slide changes to ensure all images are displayed and loaded eagerly
    handleImageLoading() {
      let galleryImages = this.querySelectorAll('img.mobile-image.hidden');
      if(window.innerWidth >= 990){
        galleryImages = this.querySelectorAll('img.desktop-image.hidden');
      }
      galleryImages.forEach(image => {
        image.classList.remove('hidden');
        image.removeAttribute('loading');
      });
    }

    scrollSpy() {
    const topSpacing = 50; // Adjust this value for the desired top spacing

    // Move to coresponding image when click on thumbs link
    this.triggers.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const target = document.querySelector(`#${link.dataset.target}`);
        const targetOffset = target.getBoundingClientRect().top + window.pageYOffset - topSpacing;
        const currentPosition = window.pageYOffset;
        const distance = targetOffset - currentPosition;
        const duration = 600;
        let startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          const progress = timestamp - startTime;
          const percentage = Math.min(progress / duration, 1);

          window.scrollTo(0, currentPosition + distance * percentage);

          if (progress < duration) {
            window.requestAnimationFrame(step);
          }
        }

        window.requestAnimationFrame(step);

        // Remove 'active' class from all links and add it to the clicked link
        link.debouncedOnClick = debounce((event) => {
          this.triggers.forEach(function(item) {
            item.classList.remove('active');
          });

          link.classList.add('active');
        }, 600);

        link.debouncedOnClick()
      });
    });
  }

    toggleActiveClass(trigger) {
      this.triggers.forEach(thumb => {
        thumb.classList.remove('active');
      });

      trigger.classList.add('active');

      const target = trigger.dataset.target;
      const bigImage = document.querySelector(`#${target}`);

      if (bigImage) {
        bigImage.scrollIntoView({ behavior: "smooth" });
      }
    }

    scrNav() {
      const headerHeight = `${this.header.offsetHeight}px`;
      document.documentElement.style.setProperty('--header-height', headerHeight);
      const scrollTop = window.scrollY;

      this.big.forEach(section => {
        const id      = section.getAttribute('id');
        const offset  = section.offsetTop - 1;
        const height  = section.clientHeight;

        if (scrollTop >= offset && scrollTop < offset + height) {
          this.triggers.forEach(link => {
            link.classList.remove('active');
          });

          const imageSelector = document.querySelector('[data-target="' + id + '"]');

          if (imageSelector != null) {
            const slide = imageSelector.closest('.swiper-slide');

            if (slide != null && slide.hasAttribute('aria-label')) {
              const slideIndex = Number(slide.getAttribute('aria-label').split(' / ')[0]);
              imageSelector.classList.add('active');

              if (slideIndex != null) {
                this.thumbs.slideTo(slideIndex-1);
              };
            }
          };
        }
      });
    }
  }

  customElements.define('product-slider', ProductSlider);
})();
